import { render, staticRenderFns } from "./LiveShare.vue?vue&type=template&id=571335c6&scoped=true&"
import script from "./LiveShare.vue?vue&type=script&lang=js&"
export * from "./LiveShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571335c6",
  null
  
)

export default component.exports